var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgReport = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "#1B1F23",
  "aria-hidden": "true",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10 16v2H3v13a1 1 0 1 1-2 0V1a1 1 0 0 1 2 0v1h12.5A1.5 1.5 0 0 1 17 3.5V6h12.793a1.5 1.5 0 0 1 1.06 2.56L25.415 14l5.44 5.44A1.5 1.5 0 0 1 29.793 22H15a3 3 0 0 1-3-3V7.01a1 1 0 0 1 .2-.61L14 4H3v12zm4-8v11a1 1 0 0 0 1 1h13.586l-4.94-4.94a1.5 1.5 0 0 1 0-2.12L28.586 8z"
})));
export default SvgReport;